import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-xl px-3 py-2 shadow-warm-md border border-surface-200 text-sm space-y-1">
      <p className="font-semibold text-ink-800">{label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} className="text-ink-500 flex items-center gap-2">
          <span className="inline-block w-2 h-2 rounded-full" style={{ backgroundColor: p.color }} />
          <span>{p.name}:</span>
          <span className="font-medium">{(p.value || 0).toLocaleString()}</span>
        </p>
      ))}
    </div>
  );
};

const AndroidDownloadsChart = ({ stats }) => {
  const data = (stats || []).map((s) => ({
    date: s.date?.slice(5) || s.id?.slice(5),
    firstTime: s.androidFirstTimeDownloads || 0,
    updates: s.androidUpdates || 0,
  }));

  const hasAnyData = data.some((d) => d.firstTime > 0 || d.updates > 0);

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-bold text-ink-900 text-[0.9375rem]">Android downloads</h3>
        <span className="text-xs text-ink-400">Last 30 days</span>
      </div>
      <p className="text-xs text-ink-400 mb-5">
        New installs vs updates from Google Play install statistics.
      </p>
      {hasAnyData ? (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e0d6" vertical={false} />
            <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#57534e' }} axisLine={{ stroke: '#e5e0d6' }} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: '#57534e' }} axisLine={false} tickLine={false} allowDecimals={false} />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(59, 166, 118, 0.05)' }} />
            <Legend iconType="circle" wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
            <Bar dataKey="firstTime" name="New installs" fill="#3BA676" radius={[4, 4, 0, 0]} />
            <Bar dataKey="updates" name="Updates" fill="#B8B2A8" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[260px] flex flex-col items-center justify-center gap-2 bg-surface-50 rounded-xl border border-dashed border-surface-200">
          <p className="text-sm font-semibold text-ink-700">Awaiting Google Play install stats</p>
          <p className="text-xs text-ink-400 text-center max-w-sm px-4">
            Grant the Cloud Function service account "download bulk reports" access in
            Play Console → Users and permissions, then set the PLAY_REPORT_BUCKET secret.
            The daily job (11:00 UTC) fills these once reports publish.
          </p>
        </div>
      )}
    </div>
  );
};

export default AndroidDownloadsChart;
